import { Box, Typography } from "@mui/material";

// Tooltip body shared by all charts: optional title, then rows of
// color dot · label · value.
const ChartTooltip = ({ title, rows }) => (
  <Box
    sx={{
      backgroundColor: "#ffffff",
      border: "1px solid #e3e5e9",
      borderRadius: "8px",
      boxShadow: "0 8px 16px rgba(145, 158, 171, 0.24)",
      px: 1.5,
      py: 1,
      minWidth: 160,
    }}
  >
    {title && (
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "text.secondary", mb: 0.5 }}>
        {title}
      </Typography>
    )}
    {rows.map((row) => (
      <Box
        key={row.id}
        sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.25 }}
      >
        {row.color && (
          <Box
            component="span"
            sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: row.color, flexShrink: 0 }}
          />
        )}
        <Typography sx={{ fontSize: 13, color: "text.secondary", flex: 1, whiteSpace: "nowrap" }}>
          {row.label}
        </Typography>
        <Typography
          sx={{ fontSize: 13, fontWeight: 600, color: "text.primary", fontVariantNumeric: "tabular-nums" }}
        >
          {row.value}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default ChartTooltip;
